import type { UsageTotal } from "@/terminal/monitoring/monitoring-usage"

export const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format

// Pure, so the client's usage view sums totals without loading the usage
// queries.
export const emptyTotal = (): UsageTotal => ({
  known: 0,
  estimated: 0,
  pendingRequests: 0,
  unknownRequests: 0,
})

export const addTotal = (total: UsageTotal, value: UsageTotal) => {
  total.known += value.known
  total.estimated += value.estimated
  total.pendingRequests += value.pendingRequests
  total.unknownRequests += value.unknownRequests
}
